import axios, { getData } from "lib/axios";

export const getAllClaimRoutes = async () => {
  return axios.get("/admin/claim-routes").then(getData);
};

export const getAllApprovalRoutes = async () => {
  return axios.get("/approval-route").then(getData);
};

export const postNewClaimRoutes = async (data) => {
  return axios.post("admin/claim-routes", data).then(getData);
};
